import { render, staticRenderFns } from "./LegalTrade.vue?vue&type=template&id=c638b7be&"
import script from "./LegalTrade.vue?vue&type=script&lang=js&"
export * from "./LegalTrade.vue?vue&type=script&lang=js&"
import style0 from "./LegalTrade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports